import { Icon, IconProps } from './Icon';

interface FriendsIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const FriendsIcon = ({ color = '#BDC9EE', gradient, ...props }: FriendsIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5273 22.472C26.8447 18.1247 26.8354 11.1007 22.4996 6.76486C18.1545 2.41977 11.1098 2.41977 6.76467 6.76486C2.41959 11.1099 2.41959 18.1547 6.76467 22.4998C11.1006 26.8358 18.125 26.8449 22.4722 22.5271C18.1549 26.8744 18.1641 33.8984 22.4999 38.2342C26.845 42.5793 33.8898 42.5793 38.2349 38.2342C42.58 33.8891 42.58 26.8444 38.2349 22.4993C33.8989 18.1633 26.8746 18.1542 22.5273 22.472Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
